module.exports = __webpack_public_path__ + "static/img/yp1.d5f2ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yp1.png
// module id = 3/2z
// module chunks = 3